import Config from '../../conf';
const Theme = Config.THEME;

export const CardDetails = {
  center: {
    textAlign: 'center',
    justifyContent: 'center'
  },
  card: {
    padding: 30,
    paddingTop: 40,
    textAlign: 'center',
    borderRadius: 12
  },
  title: {
    textAlign: 'center',
    margin: 0,
    color: Theme.palette.primary1Color,
    marginBottom: 20
  },
  dateTimeWrapper: {
    width: '80%',
    maxWidth: 440,
    margin: 'auto'
  },
  button: {
    width: 80,
    marginTop: 20,
    marginLeft: 5,
    marginRight: 5
  },
  inputStyle: {
    width: '100%',
    textAlign: 'center',
    justifyContent: 'center'
  },
  textField: {
    padding: 0,
    margin: 0,
    marginTop: -15,
    width: '100%'
  },
  hintStyle: {
    width: '100%',
    color: '#ccc',
    textAlign: 'center',
    justifyContent: 'center'
  },
  dialogButton: {
    margin: 5
  }
};

export const CarDetails = {
  center: {
    textAlign: 'center',
    justifyContent: 'center'
  },
  card: {
    padding: 30,
    paddingTop: 40,
    textAlign: 'center',
    borderRadius: 12
  },
  title: {
    textAlign: 'center',
    margin: 0,
    color: Theme.palette.primary1Color,
    marginBottom: 20
  },
  dateTimeWrapper: {
    width: '80%',
    maxWidth: 440,
    margin: 'auto'
  },
  button: {
    width: 80,
    marginTop: 20,
    marginLeft: 5,
    marginRight: 5
  },
  inputStyle: {
    width: '100%',
    textAlign: 'center',
    justifyContent: 'center'
  },
  textField: {
    padding: 0,
    margin: 0,
    marginTop: -15,
    width: '100%'
  },
  hintStyle: {
    width: '100%',
    color: '#ccc',
    textAlign: 'center',
    justifyContent: 'center'
  },
  dialogButton: {
    margin: 5
  }
};

export const Confirm = {
  card: {
    padding: 30,
    paddingTop: 40,
    textAlign: 'center',
    borderRadius: 12
  },
  title: {
    textAlign: 'center',
    margin: 0,
    color: Theme.palette.primary1Color,
    marginBottom: 20
  },
  button: {
    width: 100,
    marginTop: 20,
    marginLeft: 5,
    marginRight: 5
  },
  field: {
    padding: 0,
    margin: 0,
    marginTop: -15,
    width: '100%'
  },
  fieldHintStyle: {
    textAlign: 'center'
  },
  table: {
    paddingLeft: '25%',
    paddingRight: '25%',
    paddingTop: 30,
    paddingBottom: 20
  },
  nameCol: {
    textAlign: 'center',
    fontWeight: 'bold'
  },
  valueCol: {
    textAlign: 'center'
  }
};


export const ConfirmAndPay = {
  card: {
    padding: 30,
    paddingTop: 40,
    textAlign: 'center',
    borderRadius: 12
  },
  title: {
    textAlign: 'center',
    margin: 0,
    color: Theme.palette.primary1Color,
    marginBottom: 20
  },
  button: {
    width: 100,
    marginTop: 20,
    marginLeft: 5,
    marginRight: 5
  },
  field: {
    padding: 0,
    margin: 0,
    marginTop: -15,
    width: '100%'
  },
  fieldHintStyle: {
    textAlign: 'center'
  },
  table: {
    paddingLeft: '25%',
    paddingRight: '25%',
    paddingTop: 30,
    paddingBottom: 20
  },
  nameCol: {
    textAlign: 'center',
    fontWeight: 'bold'
  },
  valueCol: {
    textAlign: 'center'
  }
};

export const CustomerDetails = {
  card: {
    padding: 30,
    paddingTop: 40,
    textAlign: 'center',
    borderRadius: 12
  },
  title: {
    textAlign: 'center',
    margin: 0,
    color: Theme.palette.primary1Color,
    marginBottom: 20
  },
  button: {
    width: 80,
    marginTop: 20,
    marginLeft: 5,
    marginRight: 5
  },
  wrapper: {
    width: '80%',
    maxWidth: 390,
    margin: 'auto',
    marginTop: 10
  },
  field: {
    padding: 0,
    margin: 0,
    marginTop: -15,
    width: '100%'
  },
  inputStyle: {
    width: '100%',
    textAlign: 'center',
    justifyContent: 'center'
  },
  hintStyle: {
    width: '100%',
    color: '#ccc',
    textAlign: 'center',
    justifyContent: 'center'
  },
  paragraph: {
    margin: 10,
    marginBottom: 20
  },
  dialogButton: {
    margin: 2
  }
};

export const Details = {
  card: {
    padding: 30,
    paddingTop: 40,
    textAlign: 'center',
    borderRadius: 12
  },
  title: {
    textAlign: 'center',
    margin: 0,
    color: Theme.palette.primary1Color,
    marginBottom: 10
  },
  subTitle: {
    textAlign: 'center',
    margin: 0,
    color: '#000',
    marginBottom: 10
  },  
  button: {
    width: 80,
    marginTop: 10
  },
  wrapper: {
    width: '80%',
    maxWidth: 390,
    margin: 'auto',
    marginTop: 10
  },
  field: {
    padding: 0,
    margin: 0,
    marginTop: -15,
    width: '100%'
  },
  inputStyle: {
    width: '100%',
    textAlign: 'center',
    justifyContent: 'center'
  },
  hintStyle: {
    width: '100%',
    color: '#ccc',
    textAlign: 'center',
    justifyContent: 'center'
  },
  paragraph: {
    margin: 10,
    marginBottom: 20
  },
  textField: {
    marginTop: -16
  },
  imageLogo: {
    marginTop: 5,
    marginLeft: 5,
    height: '50%',
    width: '50%',
    maxWidth: 400
  },
  list: {
    textAlign: 'center'
  },
  li: {
    textAlign: 'left',
    lineHeight: '24px'
  },
  selectDiv: {
    height: '100%'
  },
  flexContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  cardContainer: {
    textAlign: 'center',
    justifyContent: 'center',
    width: '90%',
    margin: 5,
    //maxWidth: 400,
    minWidth: 200,
    flex: 1,
    position: 'relative',
    paddingBottom: 15,
    borderRadius: 12
  },
  subcard: {
    textAlign: 'center',
    justifyContent: 'center',
    display: 'flex',
    flex: 1,
    paddingBottom:'0px'
  },
  cardTitle: {
    marginBottom: 0,
    color: Theme.palette.primary1Color
  },
  cardSubTitle: {
    marginTop: 0,
    marginBottom: 0,
    color: Theme.palette.primary1Color
  },
  center: {
    textAlign: 'center',
    justifyContent: 'center'
  }  
};


export const WashDetails = {
  flexContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  cardContainer: {
    textAlign: 'center',
    justifyContent: 'center',
    width: '90%',
    margin: 5,
    //maxWidth: 400,
    minWidth: 200,
    flex: 1,
    position: 'relative',
    paddingBottom: 85,
    borderRadius: 12
  },
  title: {
    textAlign: 'center',
    margin: 0,
    color: Theme.palette.primary1Color,
    paddingTop: 10,
    marginBottom: 20
  },
  card: {
    textAlign: 'center',
    justifyContent: 'center',
    display: 'flex',
    flex: 1
  },
  cardTitle: {
    marginBottom: 0,
    color: Theme.palette.primary1Color
  },
  center: {
    textAlign: 'center',
    justifyContent: 'center'
  },
  list: {
    textAlign: 'center'
  },
  li: {
    textAlign: 'left',
    lineHeight: '24px'
  },
  selectDiv: {
    height: '100%'
  },
  priceText: {
    position: 'absolute',
    bottom: 75,
    left: '50%',
    width: 120,
    marginLeft: -60,
    fontWeight: 'bold'
  },
  chooseButton: {
    position: 'absolute',
    bottom: 25,
    left: '50%',
    width: 120,
    marginLeft: -60
  },
  backButton: {
    width: 80,
    margin: 20
  },
  dialogButton: {
    margin: 5
  }
};




// WEBPACK FOOTER //
// ./src/app/components/form/form.css.js